module.exports = __webpack_public_path__ + "static/media/A18040103_10002_5.bb8d2138.jpg";